var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.60186C0 7.94923 0.318422 7.33765 0.853075 6.96339L8.85307 1.36339C9.54171 0.881347 10.4583 0.881346 11.1469 1.36339L19.1469 6.96339C19.6816 7.33765 20 7.94923 20 8.60186V18.5605C20 19.6651 19.1046 20.5605 18 20.5605H2C0.895431 20.5605 0 19.6651 0 18.5605V8.60186Z",
    fill: "#040404"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_256_1096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.560547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.03df2fb79129af08d8b1aead8f29b639.svg";
export { ForwardRef as ReactComponent };